import axios from "axios";
import { domainKey } from './globalUtility';

const apiEndPoint = '';
 
const axiosInstance = axios.create({
    baseURL: apiEndPoint,
    headers: {
      "Content-type": "application/json"
    },
  });

// Interceptor to dynamically set domain-key header on each request
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['domain-key'] = domainKey;
    return config;
  },
  (error) => Promise.reject(error)
);

const executePostReturnResult = async (endpoint, payLoad) => {
  try {
    const result = await axiosInstance.post(`${endpoint}`, payLoad);
    return { result };
  } catch(err) {
    return { success: false };
  }
};

export const validateBankNumber = async (bankNumber) => {
    const payload = {"bankNumber" : bankNumber};
    const response = await executePostReturnResult('/api/bankValidation/validateInstitutionNumber', payload)
    return response
}
 
export const validateBranchNumber = async (bankNumber, branchNumber) => {
    const payload = {
        "bankNumber" : bankNumber,
        "branchNumber" : branchNumber
    };
    return await executePostReturnResult('/api/bankValidation/validateTransitNumber', payload)
}
 
export const validateBankAccount = async (bankNumber, branchNumber, bankAccount) => {
    const payload = {
        "bankNumber" : bankNumber,
        "branchNumber" : branchNumber,
        "bankAccount" : bankAccount
    };
    return await executePostReturnResult('/api/bankValidation/validateBankAccount', payload)
}

export const isValidBankNumber = async (bankNumber) => {
  return await validateBankNumber(bankNumber).then(response => response?.result?.data);
};
 
export const isValidBranchNumber = async (bankNumber, branchNumber) => {
  return await validateBranchNumber(bankNumber, branchNumber).then(response => response);
}
 
export const isValidBankAccount = async (bankNumber, branchNumber, bankAccount) => {
  return await validateBankAccount(bankNumber, branchNumber, bankAccount).then(response => response);
};

export const getBankNameFromNumber = (bankNumber) => {
  const bank = bankList.find((x) => x.institutionNumber === bankNumber);

  return bank?.name || "";
};

export const bankList = [
  { institutionNumber: "001", name: "Bank of Montreal", city: "Montreal", province: "QC" },
  { institutionNumber: "002", name: "The Bank of Nova Scotia (Scotiabank)", city: "Toronto", province: "ON" },
  { institutionNumber: "003", name: "Royal Bank of Canada (RBC)", city: "Montreal", province: "QC" },
  { institutionNumber: "004", name: "The Toronto-Dominion Bank (TD)", city: "Mississauga", province: "ON" },
  { institutionNumber: "006", name: "National Bank of Canada", city: "Montreal", province: "QC" },
  { institutionNumber: "010", name: "Canadian Imperial Bank of Commerce (CIBC)", city: "Toronto", province: "ON" },
  { institutionNumber: "016", name: "HSBC Bank Canada", city: "Vancouver", province: "BC" },
  { institutionNumber: "030", name: "Canadian Western Bank", city: "Edmonton", province: "AB" },
  { institutionNumber: "039", name: "Laurentian Bank of Canada", city: "Montreal", province: "QC" },
  { institutionNumber: "117", name: "President's Choice Financial", city: "Toronto", province: "ON" },
  { institutionNumber: "177", name: "Bank of Canada", city: "Ottawa", province: "ON" },
  { institutionNumber: "219", name: "ATB Financial", city: "Edmonton", province: "AB" },
  { institutionNumber: "260", name: "Citibank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "275", name: "KEB Hana Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "290", name: "UBS Bank (Canada)", city: "Toronto", province: "ON" },
  { institutionNumber: "294", name: "SBI Canada Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "303", name: "Amex Bank of Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "307", name: "Industrial and Commercial Bank of China (Canada)", city: "Richmond Hill", province: "ON" },
  { institutionNumber: "308", name: "Bank of China (Canada)", city: "Toronto", province: "ON" },
  { institutionNumber: "309", name: "Vancity Community Investment Bank", city: "Vancouver", province: "BC" },
  { institutionNumber: "310", name: "First Nations Bank of Canada", city: "Saskatoon", province: "SK" },
  { institutionNumber: "314", name: "J.P. Morgan Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "315", name: "CTBC Bank Corp. (Canada)", city: "Vancouver", province: "BC" },
  { institutionNumber: "320", name: "President's Choice Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "321", name: "Habib Canadian Bank", city: "Mississauga", province: "ON" },
  { institutionNumber: "326", name: "Canadian Imperial Bank of Commerce", city: "Toronto", province: "ON" },
  { institutionNumber: "334", name: "VersaBank", city: "London", province: "ON" },
  { institutionNumber: "338", name: "Canadian Tire Bank", city: "St. Catharines", province: "ON" },
  { institutionNumber: "340", name: "ICICI Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "343", name: "ADS Canadian Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "344", name: "General Bank of Canada", city: "Edmonton", province: "AB" },
  { institutionNumber: "347", name: "Bridgewater Bank", city: "Edmonton", province: "AB" },
  { institutionNumber: "352", name: "Digital Commerce Bank", city: "Calgary", province: "AB" },
  { institutionNumber: "355", name: "Shinhan Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "356", name: "Citco Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "358", name: "HomeEquity Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "359", name: "Duo Bank of Canada", city: "Mississauga", province: "ON" },
  { institutionNumber: "361", name: "Home Bank", city: "Oakville", province: "ON" },
  { institutionNumber: "368", name: "Rogers Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "370", name: "Wealth One Bank of Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "374", name: "Motus Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "376", name: "Exchange Bank of Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "377", name: "RFA Bank of Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "378", name: "Cidel Bank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "381", name: "Haventree Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "382", name: "Coast Capital Savings Federal Credit Union", city: "Surrey", province: "BC" },
  { institutionNumber: "383", name: "Peoples Bank of Canada", city: "Vancouver", province: "BC" },
  { institutionNumber: "507", name: "Community Trust Company", city: "Mississauga", province: "ON" },
  { institutionNumber: "509", name: "The Canada Trust Company", city: "Mississauga", province: "ON" },
  { institutionNumber: "522", name: "Trust La Laurentienne du Canada Inc.", city: "Montreal", province: "QC" },
  { institutionNumber: "532", name: "Effort Trust Company", city: "Hamilton", province: "ON" },
  { institutionNumber: "536", name: "Investors Group Trust Co. Ltd.", city: "Winnipeg", province: "MB" },
  { institutionNumber: "540", name: "Manulife Bank of Canada", city: "Waterloo", province: "ON" },
  { institutionNumber: "608", name: "CS Alterna Bank", city: "Ottawa", province: "ON" },
  { institutionNumber: "614", name: "Tangerine Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "618", name: "B2B Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "623", name: "Equitable Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "701", name: "Concentra Bank", city: "Saskatoon", province: "SK" },
  { institutionNumber: "702", name: "Meridian Credit Union Limited", city: "Toronto", province: "ON" },
  { institutionNumber: "703", name: "Alterna Savings and Credit Union", city: "Ottawa", province: "ON" },
  { institutionNumber: "708", name: "Servus Credit Union", city: "Edmonton", province: "AB" },
  { institutionNumber: "803", name: "Coast Capital Savings Credit Union", city: "Surrey", province: "BC" },
  { institutionNumber: "809", name: "Vancity Credit Union", city: "Vancouver", province: "BC" },
  { institutionNumber: "828", name: "FirstOntario Credit Union", city: "Hamilton", province: "ON" },
  { institutionNumber: "838", name: "Connect First Credit Union", city: "Calgary", province: "AB" },
  { institutionNumber: "879", name: "Steinbach Credit Union", city: "Steinbach", province: "MB" },
  { institutionNumber: "939", name: "Kindred Credit Union", city: "Kitchener", province: "ON" },
  { institutionNumber: "989", name: "BlueShore Financial", city: "North Vancouver", province: "BC" },
  { institutionNumber: "241", name: "Bank of America, National Association", city: "Toronto", province: "ON" },
  { institutionNumber: "242", name: "The Bank of New York Mellon", city: "Toronto", province: "ON" },
  { institutionNumber: "245", name: "MUFG Bank, Ltd., Canada Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "250", name: "BNP Paribas", city: "Montreal", province: "QC" },
  { institutionNumber: "265", name: "Deutsche Bank AG", city: "Toronto", province: "ON" },
  { institutionNumber: "269", name: "Mega International Commercial Bank Co., Ltd.", city: "Toronto", province: "ON" },
  { institutionNumber: "270", name: "JPMorgan Chase Bank, National Association", city: "Toronto", province: "ON" },
  { institutionNumber: "277", name: "Mizuho Bank Ltd.", city: "Toronto", province: "ON" },
  { institutionNumber: "301", name: "Sumitomo Mitsui Banking Corporation, Canada Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "318", name: "U.S. Bank National Association", city: "Toronto", province: "ON" },
  { institutionNumber: "322", name: "Rabobank Canada", city: "Toronto", province: "ON" },
  { institutionNumber: "323", name: "Capital One Bank (Canada Branch)", city: "Toronto", province: "ON" },
  { institutionNumber: "327", name: "State Street", city: "Toronto", province: "ON" },
  { institutionNumber: "328", name: "Citibank, N.A", city: "Toronto", province: "ON" },
  { institutionNumber: "330", name: "Comerica Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "332", name: "First Commercial Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "335", name: "United Overseas Bank Limited", city: "Vancouver", province: "BC" },
  { institutionNumber: "345", name: "Fifth Third Bank, National Association", city: "Toronto", province: "ON" },
  { institutionNumber: "346", name: "Société Générale (Canada Branch)", city: "Toronto", province: "ON" },
  { institutionNumber: "349", name: "The Northern Trust Company, Canada Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "357", name: "M & T Bank", city: "Toronto", province: "ON" },
  { institutionNumber: "360", name: "Barclays Bank PLC, Canada Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "362", name: "Wells Fargo Bank, National Association, Canadian Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "365", name: "PNC Bank Canada Branch", city: "York", province: "ON" },
  { institutionNumber: "366", name: "China Construction Bank Toronto Branch", city: "Toronto", province: "ON" },
  { institutionNumber: "372", name: "Bank of China, Toronto Branch", city: "Toronto", province: "ON" }
];